<template>
  <v-container>
    <PageHeader subtitle="Manage discrete and continuous station categories across the system." />

    <v-tabs v-model="model" dark grow centered>
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1">
        <v-icon class="mr-1">assignment</v-icon>{{ $t('AdministrationStationCategoryManage.DiscreteSampleStationCategory') }}
      </v-tab>
      <v-tab href="#tab-2">
        <v-icon class="mr-1">mdi-clock</v-icon>{{ $t('AdministrationStationCategoryManage.ContinuousDataStationCategory') }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="model">
      <v-tab-item value="tab-1">
        <AdministrationStationDiscreteCategory />
      </v-tab-item>
      <v-tab-item value="tab-2">
        <AdministrationStationContinuousCategory />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import AdministrationStationDiscreteCategory from '@/components/Administration/StationCategory/AdministrationStationDiscreteCategory'
  import AdministrationStationContinuousCategory from '@/components/Administration/StationCategory/AdministrationStationContinuousCategory'
  const stations = createNamespacedHelpers('stations')

  export default {
    components: {
      AdministrationStationDiscreteCategory,
      AdministrationStationContinuousCategory,
    },
    data() {
      return {
        model: 'tab-1',
      }
    },
    mounted() {},
    computed: {
      ...stations.mapGetters(['stationCategories', 'iconList']),
    },
    methods: {
      ...stations.mapActions([
        'getStationCategories',
        'postAddStationCategory',
        'putUpdateStationCategory',
      ]),
    },
  }
</script>